<div class="d-f jc-end mb-xs" *ngIf="(isLoading$ | async) === false">
	<mat-form-field appearance="outline" class="status-filter-field">
		<mat-label>Filtrar por Status</mat-label>
		<mat-select [formControl]="statusFilterControl">
			<mat-option *ngFor="let option of filterOptions" [value]="option.value">
				{{ option.label }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field appearance="outline" class="operation-filter-field ml-xxxs">
		<mat-label>Filtrar por Operação</mat-label>
		<mat-select [formControl]="operationFilterControl">
			<mat-option
				*ngFor="let option of operationFilterOptions"
				[value]="option.value"
			>
				{{ option.label }}
			</mat-option>
		</mat-select>
	</mat-form-field>
</div>

<div class="d-f jc-c ai-c w-100 mt-md" *ngIf="isLoading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>

<ng-container *ngIf="(isLoading$ | async) === false">
	<ng-container *ngIf="batchActions$ | async as batchActions">
		<div *ngIf="batchActions.length === 0">
			<p class="mt-xs fs-i gray">
				<ng-container *ngIf="statusFilterControl.value === 'all'">
					Nenhuma ação em massa encontrada.
				</ng-container>
				<ng-container *ngIf="statusFilterControl.value !== 'all'">
					Nenhuma ação encontrada para o filtro selecionado.
				</ng-container>
			</p>
		</div>

		<div
			class="pos-r mb-xxxs pb-nano br-md c-p card"
			*ngFor="let ba of batchActions"
			(click)="onViewDetails(ba.id)"
		>
			<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs mr-xxxs br-md">
				<div class="d-f jc-sb ai-c ml-xxxs top">
					<div class="d-f fd-c jc-c col">
						<span class="fs-xxxs fw-bold lh-xxxs gray">Operador</span>
						<span class="mt-quark fs-xxs lh-md to-ellipsis">
							{{ ba.userName | titlecase }}
						</span>
					</div>
					<div class="d-f fd-c jc-c col">
						<span class="fs-xxxs fw-bold lh-xxxs gray">Empresa</span>
						<span class="mt-quark fs-xxs lh-md to-ellipsis">
							{{ ba.organizationName }}
						</span>
					</div>
					<div class="d-f fd-c jc-c col date">
						<span class="fs-xxxs fw-bold lh-xxxs gray">Data do upload</span>
						<span class="mt-quark fs-xxs lh-md to-ellipsis">
							{{ ba.createdAt | date: 'dd/MM/YYYY HH:mm' }}
						</span>
					</div>
					<div class="d-f fd-c jc-c col">
						<span class="fs-xxxs fw-bold lh-xxxs gray">Operação</span>
						<span class="mt-quark fs-xxs lh-md to-ellipsis">
							{{ batchActionOperationLabel(ba) }}
						</span>
					</div>
					<div class="d-f fd-c jc-c col link">
						<span
							class="mt-quark fs-xxs lh-md to-ellipsis sub c-p"
							(click)="onDownloadFile(ba.fileKey, $event)"
							(keydown)="$event.stopPropagation()"
							tabindex="0"
							role="button"
							aria-label="Baixar arquivo"
						>
							Baixar arquivo
						</span>
					</div>
					<div class="d-f fd-c jc-c col status">
						<span
							class="mt-quark fs-xxs lh-md chip"
							[class.purple]="ba.status === uploadStatus.SCHEDULED"
							[class.red]="ba.status === uploadStatus.FAILURE"
							[class.blue]="ba.status === uploadStatus.IN_PROCESS"
							[class.green]="ba.status === uploadStatus.SUCCESS"
							[class.grey]="ba.status === uploadStatus.CANCELLED"
						>
							{{ statusLabel(ba.status) }}
						</span>

						<button
							*ngIf="ba.status === uploadStatus.SCHEDULED"
							mat-stroked-button
							(click)="onCancelSchedule(ba.id, $event)"
							class="cancel-button mt-nano"
						>
							Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-container>

<div class="mb-huge"></div>
